const topics = [
  { name: '#韩漫推荐', count: '12.8万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#日漫经典', count: '9.6万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#国漫崛起', count: '8.3万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '#恋爱漫画', count: '15.2万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#热血战斗', count: '11.4万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#悬疑推理', count: '6.7万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '#免费漫画', count: '20.1万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '#下拉式阅读', count: '5.3万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '#漫画大全', count: '18.9万讨论', color: 'bg-secondary-100 text-secondary-700' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            漫友圈最热话题讨论，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className={`group px-4 py-2.5 rounded-full ${item.color} cursor-pointer hover:scale-105 transition-transform flex items-center gap-2`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}